import { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import InfoIcon from '@mui/icons-material/Info';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { useReset } from '../../context/ResetContext';

interface BurgerMenuProps {
  onReset: () => void;
}

const BurgerMenu = ({ onReset }: BurgerMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openAboutDialog, setOpenAboutDialog] = useState(false);
  const [openResetConfirm, setOpenResetConfirm] = useState(false);
  const { triggerReset } = useReset();
  
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const handleResetRequest = () => {
    setOpenResetConfirm(true);
    handleClose();
  };
  
  const handleReset = () => {
    onReset();
    triggerReset();
    setOpenResetConfirm(false);
  };
  
  const handleAboutClick = () => {
    setOpenAboutDialog(true);
    handleClose();
  };
  
  const handleSupportClick = () => {
    window.open("https://www.paypal.com/paypalme/crono972", "paypalFhocs");
    handleClose();
  };
  
  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        color="inherit"
      >
        <MenuIcon />
      </IconButton>
      
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: '200px',
            maxHeight: 48 * 4.5,
            mt: 1,
            borderRadius: 2,
            boxShadow: 3
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleResetRequest}>
          <ListItemIcon>
            <RestartAltIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Recommencer</ListItemText>
        </MenuItem>
        
        <MenuItem onClick={handleSupportClick}>
          <ListItemIcon>
            <VolunteerActivismIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Soutenir le projet</ListItemText>
        </MenuItem>
        
        <MenuItem onClick={handleAboutClick}>
          <ListItemIcon>
            <InfoIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>À propos</ListItemText>
        </MenuItem>
      </Menu>
      
      {/* About Dialog */}
      <Dialog
        open={openAboutDialog}
        onClose={() => setOpenAboutDialog(false)}
      >
        <DialogTitle>À propos</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Site web réalisé par FHocs (frederic@hocansung.com)
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAboutDialog(false)} color="primary">
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Reset Dialog */}
      <Dialog
        open={openResetConfirm}
        onClose={() => setOpenResetConfirm(false)}
      >
        <DialogTitle>Recommencer</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Vous allez perdre toute votre progression, êtes-vous sûr ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenResetConfirm(false)} color="primary">
            Annuler
          </Button>
          <Button onClick={handleReset} color="primary" variant="contained">
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BurgerMenu;
